<app-graph-konva
        (emitEdgeEvent)="deleteElement($event,false)"
        (emitNodeEvent)="handleNodeEvent($event)"
        [graphType]="'common'"
        [graphUISetting]="graphUISetting"
        [layoutDagreSettings]="layoutDagreSettings"
        [stageSettings]="stageSettings"
>
</app-graph-konva>
<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
<ng-template #deleteStatusNode  let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1 style="margin-bottom: 15px;">{{ 'MODALS.HEADERS.DELETE_STATUS' | translate }} {{ graphService.deleteStatus.label }}</h1>
        <small>{{ 'MODALS.TEXT.SELECT_TO_DELETE_STATUS' | translate }}</small>
        <div style="margin-bottom: 15px;">
            <div style="margin-bottom: 15px; margin-top: 10px;">
                <select [(ngModel)]="graphService.selectedStatus" class="form-select"
                        style="margin-bottom: 10px;">
                    <option [ngValue]="null"
                            hidden>{{ 'MODALS.FIELDS.SELECT.STATUS' | translate }}
                    </option>
                    <option *ngFor="let status of graphService.copyNodes"
                            [ngValue]="status">{{ status.label }}
                    </option>
                </select>
            </div>
        </div>

        <strong>{{ 'MODALS.TEXT.CONFIRM_DELETE_STATUS' | translate }}</strong>
        <input #statusName
               class="form-control"
               required
               type="text">
        <button (click)="onDeleteStatus(statusName.value, modal)"
                [disabled]="isLockButton"
                class="btn btn-block btn-success"
                data-action='deleteStatus'
                style="margin-top: 15px">
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.DELETE' | translate }}</span>
        </button>
    </div>
</ng-template>